import { IOType } from '@erp/shared-types/node-graph';

interface IOSpanProps {
  ioType: IOType;
  text: string;
}

export function IOSpan({ ioType, text }: IOSpanProps) {
  return (
    <p
      className={`text-xs my-0.5 ${
        ioType === IOType.INPUT ? 'text-left' : 'text-right'
      }`}
    >
      {text}
    </p>
  );
}
